import React from "react";

const Tag = ({tag, classTag})=>(
   
    <div className="tag">
        <span  className={classTag}>{tag}</span>
    </div>
)

export default Tag